import {handleDropdownSwitchElement} from "./dropdown-switch-handler.js";
document.querySelectorAll(".ce--container_dsmw-dropdownSwitch").forEach((e) => handleDropdownSwitchElement(e));
